import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { DhContabilidadConstant } from 'constants/index'

const DhFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='D/H' htmlFor='select-dh' md={12} />
      <Col md={12}>
        <Field name='dh'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-dh'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {DhContabilidadConstant.__array.map((val, key) => (
                <option key={key} value={val.id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DhFormGroup)
